"use client";

import { c as _c } from "react/compiler-runtime";
import { ContentBlock } from "../../ui/ContentBlock";
import { Button } from "../../uiv7/Button";
import type { Route } from "next";
import { barlowCondensed, roboto } from "../../../utils/fonts";
import { cn } from "@local/utils/src/cn";
import { SingleCategoryCard } from "./SingleCategoryCard";
import { CssCarousel } from "../../ui/CssCarousel";
import type { Offer } from "@local/offer/src/types";
import { ArrowTitle } from "../../ui/ArrowTitle";
export const CategoriesListing = t0 => {
  const $ = _c(20);
  const {
    content,
    market
  } = t0;
  const {
    headline,
    ctaText,
    categories
  } = content;
  const currentHeadline = headline ?? "Shop by Category";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("mt-8 mb-4 flex !max-w-6xl flex-col justify-center py-10 lg:py-6", barlowCondensed.className);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currentHeadline) {
    t2 = <ArrowTitle headline={currentHeadline} />;
    $[1] = currentHeadline;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${currentHeadline} carousel`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      base: 1.5,
      sm: 2,
      md: 4
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== categories || $[5] !== market) {
    t5 = categories?.map((category, i) => <div key={`${category?.id}-${i}-category-card`} className="w-full"><SingleCategoryCard category={category} market={market} /></div>);
    $[4] = categories;
    $[5] = market;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className="relative px-0 py-8 sm:px-8"><CssCarousel ariaLabel={t3} showArrows={true} roundedArrows={true} showScroll={true} showDots={false} slidesPerView={t4}>{t5}</CssCarousel></div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t6) {
    t7 = <div className="mx-6 xl:mx-0">{t2}{t6}</div>;
    $[10] = t2;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `/${market}/category` as Route;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("mx-auto w-full max-w-[360px] py-6! uppercase", roboto.className);
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = ctaText ?? "View All Categories";
  let t11;
  if ($[14] !== t10 || $[15] !== t8) {
    t11 = <Button as="link" href={t8} prefetch={false} className={t9}>{t10}</Button>;
    $[14] = t10;
    $[15] = t8;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t7) {
    t12 = <ContentBlock className={t1}>{t7}{t11}</ContentBlock>;
    $[17] = t11;
    $[18] = t7;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};